import { useCallback } from 'react'
import Form from '@components/form/FormWithContext'
import HiddenInput from '@components/form/context/HiddenInput'
import Input from '@components/form/context/Input'
import SubmitButton from '@components/form/context/SubmitButton'
import Icon from '@components/shared/Icon'
import useFormGenericHandler from '@hooks/useFormGenericPostHandler'
import useT from '@hooks/useTranslation'

import styles from '@components/chat/styles/MessageForm.module.css'

const chatInput = { t: ' ', name: 'message' }

const API = '/api/chat/message/new'

const MessageForm = ({ user, chat, showSentMessage }) => {
    const send = useCallback(
        useFormGenericHandler(API.replace(':id', chat?._id), user, showSentMessage),
        [user?._id, chat?._id, showSentMessage])

    const text = {
        wpisz: useT('Wpisz wiadomość'),
        wyslij: useT('Wyślij'),
    }

    const chatId = chat?._id

    const fromId = typeof chat?._from === 'object'
        ? chat._from._id
        : chat?._from

    const toId = typeof chat?._to === 'object'
        ? chat._to._id
        : chat?._to

    return (
        <div className={styles.wrapper}>
            <Form onSubmit={send}>
                <HiddenInput name="_chat" defaultValue={chatId} />
                <HiddenInput name="_from" defaultValue={fromId} />
                <HiddenInput name="_to" defaultValue={toId} />
                <Input {...chatInput} placeholder={text.wpisz} />
                <SubmitButton>
                    {text.wyslij} <Icon>send</Icon>
                </SubmitButton>
            </Form>
        </div>
    )
}

export default MessageForm